"use client";

import { Badge } from "@/components/ui/badge";
import { siteConfig } from "@/lib/siteConfig";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Link from "next/link";

export default function GlobalPresence() {
  return (
    <section className={"wrapper py-14 square-gradient-bg"}>
      <div className={"flex flex-col gap-5 items-center text-center"}>
        <Badge>Global Presence</Badge>
        <h1 className={"text-4xl font-bold"}>
          Our <span className={"text-primary"}>Worldwide Network</span>
        </h1>
        <p className={"text-muted-foreground text-lg font-semibold"}>
          Strategically positioned across key markets to serve our clients
          better and source <br /> the best technologies globally.
        </p>
        <div
          className={"grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-5 text-start"}
        >
          {siteConfig.locations.map((location, index) => (
            <div
              key={index}
              className={"flex flex-col gap-5 items-start border p-8 rounded"}
            >
              <span className={"text-primary bg-primary/10 p-5 rounded-full"}>
                <location.icon />
              </span>
              <span className={"space-y-1"}>
                <h4 className={"text-primary font-semibold"}>
                  {location.type}
                </h4>
                <h1 className={"text-xl font-semibold"}>{location.city}</h1>
                <p className={"text-sm font-bold text-muted-foreground"}>
                  {location.country}
                </p>
              </span>

              <p className={"text-sm font-bold text-muted-foreground"}>
                {location.address}
              </p>
            </div>
          ))}
        </div>

        <div className={"mt-14 flex flex-col gap-5 items-center"}>
          <h1 className={"text-4xl font-bold "}>
            Ready to Partner with{" "}
            <span className={"text-primary"}>Technology Leaders?</span>
          </h1>
          <p className={"text-muted-foreground text-lg font-semibold"}>
            Join us in shaping the future of technology in Bhutan and beyond.
            Let&apos;s innovate together.
          </p>
          <span className={"flex gap-5"}>
            <Link href={"/faq#contact"}>
              <Button>
                <p>Contact Us Today</p> <ChevronRight />
              </Button>
            </Link>
            <Link href={"/features#industry-solutions"}>
              <Button variant={"secondary"}>View Our Services</Button>
            </Link>
          </span>
        </div>
      </div>
    </section>
  );
}
